/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react/button-has-type */
/* eslint-disable no-nested-ternary */
import { useTableHandlers } from 'hooks/useTableHandlers'
import { Loader } from 'shared/atoms'
import { useGetTaskLogQuery } from '../clientApiSlice'
import historySvg from '../../../assets/images/history.svg'

import './clientTask.scss'

type Props = {
  open: boolean,
  onClose: () => void,
  taskData?: any
}

const ClientTaskInfo: React.FC<Props> = ({ open, onClose, taskData }) => {
  const id = taskData?.taskId

  const { requestBody } = useTableHandlers({
    id
  })
  function formatDateTime(dateString: any) {
    const date = new Date(dateString)

    const day = String(date.getDate()).padStart(2, '0')
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const year = date.getFullYear()

    let hours = date.getHours()
    const minutes = String(date.getMinutes()).padStart(2, '0')

    const ampm = hours >= 12 ? 'PM' : 'AM'
    hours = hours % 12 || 12
    const formattedHours = String(hours).padStart(2, '0')

    return `${day}/${month}/${year} ${formattedHours}:${minutes} ${ampm}`
  }

  const { data, isLoading } = useGetTaskLogQuery({ id: requestBody.id ?? '' })

  return (
    <>
      {open && (
        <div className="custom-modal-overlay">
          <div className="custom-modal-content">
            <button onClick={onClose} className="custom-modal-close-button">
              ✕
            </button>

            <div className="custom-modal-body">
              {isLoading ? (
                <Loader label="Loading task history..." />
              ) : !data?.content?.length ? (
                <p className="custom-modal-message">No data found.</p>
              ) : (
                <div className="custom-message-list">
                  {data.content.map((item: any) => (
                    <div key={item.id} className="custom-message-item">
                      <img
                        src={historySvg}
                        alt="log icon"
                        className="message-icon"
                      />

                      <div className="message-text">{item.message}</div>
                      <div className="message-date">
                        {formatDateTime(item.createdAt)}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  )
}
export default ClientTaskInfo
